<!-- 首页 -->
<template>
  <div class="container flex flex-column height-all">
    <!-- 顶部搜索模块 -->
    <div class="searchContainer flex-shrink">
      <baseSearch :searchData="searchData" @searchClick="searchBtnClick" :isShowExport="true" @exportClick="exportBtnClick"/>
    </div>
    <!-- 主体表格 -->
    <div class="mainTable height-all overflow-hidden">
      <basetable tableBoxClass='mainTable' :tableTitle="tableTitle" :tableData="basetableinfo" :showopera="false" :currentPage="searchDataParam.pageNo" operaWidth="240"
                 :isLoading="isLoading" :pageSize="searchDataParam.pageSize" :showNumber="true" :showSelection="false"
                 :total="total" :showPage="true" @selectionChange="selectionChange" @rowDblclick="rowDblclick"
                 @currentChange="currentChange" @sizeChange="sizeChange" @openUserInfoDetails="openUserInfoDetails">
        <template v-slot:linkCount="scope">
          <div class="progressBox" v-if="scope.scope.row.percentage != -1">
            <el-progress type="circle" :percentage="scope.scope.row.percentage" :width="20" :stroke-width="3" :show-text="false" color="#4A7FF8"></el-progress>
            <span>{{scope.scope.row.linkCountText}}</span>
          </div>
        </template>
      </basetable>
    </div>
  </div>
</template>

<script>
import baseSearch from "@/components/baseSearch"
import basetable from "@/components/basetable"
import basedialog from "@/components/basedialog"
import preview from '@/utils//juageProType.js'
import tableDataSelect from "@/components/tableDataSelect"
import utils from "../../utils/utils";

export default {
  inject: ['$http', '$api', '$utils','$userUtils'],
  name: "orderList",
  components: {
    baseSearch,
    basetable,
    basedialog,
    tableDataSelect,
  },
  data() {
    return{
      searchData: [
        {
          label: "订单号",
          type: "input",
          name: "orderNo",
          value: ""
        },{
          label: "生产编码",
          type: "input",
          name: "productNum",
          value: ""
        },{
          label: "快递单号",
          type: "input",
          name: "expressNum",
          value: ""
        },{
          label: "快递公司",
          type: "select",
          name: "expressCode",
          options: [],
        }, {
          label: "打单用户",
          type: "select",
          name: "addUserId",
          options: [],
        },{
          label: "打单时间",
          type: "datetimerange",
          name: "printTime",
          value: [],
        }
      ],
      isLoading: false,
      tableTitle: [
        {
          label: '订单号',
          prop: 'orderNo',
        }, {
          label: '生产编码',
          prop: 'productNum',
          width: 250
        }, {
          label: '合并打印生产编码',
          prop: 'printProductNum',
		  width: 220
        }, {
          label: '数量',
          prop: 'workCount',
          width: 120
        }, {
          label: '快递公司',
          prop: 'expressName',
          width: 120
        }, {
          label: '快递单号',
          prop: 'expressNum',
        }, {
          label: '打单用户',
          prop: 'addUserId',
          width: 120
        }, {
          label: '打单时间',
          prop: 'addTime',
          width: 180
        }
      ],
      basetableinfo: [],
      expressModeOptions: [],  //快递方式options
      remainderOrderNum: 0,  //中通剩余单量
      orderIds: [],
      total: 0,
      searchDataParam:{
        orderNo: "",  //订单号
        productNum: "",  //生产编码
        printTime: ["", ""],  //生产时间
        pageNo: 1,
        pageSize: 20
      },
      isShowOrderDetailsCover: false,  //是否显示订单详情遮罩层
      orderDetailsInfo: {},  //订单详情
      isShowExport:true,
      currentChooseOrderIds:[],
    }
  },
  mounted() {
    //获取生产商账号筛选项
    // this.getProductUserOptions();

    //获取快递方式筛选项
    // this.getSupportExpressOptions();

    //获取已打印未发货订单列表
    // this.getOrderPrintList();

    //创建WebSocket并持续监听打单
    this.createWebSocket();

    this.getUserListApi();
  },

  methods:{
    /**
     * 获取生产商账号筛选项
     */
    getProductUserOptions() {
      let that = this;
      that.$http.post(that.$api.getProductUserOptionsApi).then(res => {
        if(res.code == 200) {
          that.searchData[0].options = [];
          res.data.forEach((item)=>{
            that.searchData[0].options.push({'label':item.name,'value':item.code})
          })
        }
      })
    },
      /**
       * 获取用户信息
       */
      getUserListApi() {
          let that = this;
          that.$http.post(that.$api.getUserListApi).then(res => {
              if(res.code == 200) {
                  that.searchData[4].options = [];
                  res.data.forEach((item)=>{
                      that.searchData[4].options.push({'label':item.realName,'value':item.userId})
                  })
              }
          })
          that.$http.post(that.$api.getCommonDictsApi,{
              "type": "快递公司编码",
          }).then(res => {
              if(res.code == 200) {
                  that.searchData[3].options = [];
                  res.data.forEach((item)=>{
                      that.searchData[3].options.push({'label':item.name,'value':item.code})
                  })
              }
          })
      },
    /**
     * 获取快递方式筛选项
     */
    getSupportExpressOptions() {
      let that = this;
      that.$http.post(that.$api.getSupportExpressOptionsApi).then(res => {
        if(res.code == 200) {
          that.expressModeOptions = res.data;
          that.searchData[7].options = [];
          res.data.forEach((item)=>{
            that.searchData[7].options.push({'label':item.name,'value':item.code})
          })
        }
      })
    },
    /**
     * 创建WebSocket
     */
    createWebSocket() {
      let that = this;
      that.socket = new WebSocket('ws://127.0.0.1:13888');
      console.log("that.socket:::", that.socket);
      // 监听消息
      that.socket.onmessage = function (event) {
        console.log('Client received a message', event);
        let dataStr = event.data;
        if (dataStr != null && dataStr != '') {
          let data = JSON.parse(dataStr);
          let taskId = "";
          if (data.cmd == 'print') {//打印
            taskId = data.taskID;
            if (data.status == 'success') {
              that.$message.success("任务id：" + taskId + ",等待打印...");
            }
          }
          if (data.cmd == 'notifyPrintResult') {//打印回调
            if (data.taskID == taskId) {
              if (data.status == 'success' && data.taskStatus == 'printed') {
                that.$message.success("任务id：" + taskId + ",打印完成...");
                  that.$utils.saveServiceLog(1,'打印完成trackNo:'+ data.printStatus[0].trackNo)
              } else {
                that.$message.error("任务id：" + taskId + ",失败原因【" + data.printStatus[0].msg + "】");
                  that.$utils.saveServiceLog(2,'失败'+ data.printStatus[0].trackNo+ ":" + data.toString())
              }
            }
          }
        }
      };
      // 监听Socket的关闭
      that.socket.onclose = function (event) {
        console.log('Client notified socket has closed', event);
      };
    },
    /**
     * 初始化获取未打印电子面单列表
     */
    getOrderPrintList() {
      let that = this;
      that.loading = true;
      that.$http.postRaw(that.$api.getPrintOrderRecordListApi, {
        "pageNo": that.searchDataParam.pageNo,
        "pageSize": that.searchDataParam.pageSize,
        "orderNo": that.searchDataParam.orderNo,
        "productNum": that.searchDataParam.productNum,
        "expressNum": that.searchDataParam.expressNum,
        "expressCode": that.searchDataParam.expressCode,
        "addUserId": that.searchDataParam.addUserId,
        "printStartTime": that.$utils.isEmpty(that.searchDataParam.printTime) ? "" : that.searchDataParam.printTime[0],
        "printEndTime": that.$utils.isEmpty(that.searchDataParam.printTime) ? "" : that.searchDataParam.printTime[1],
      }).then(res => {
        that.loading = false;
        if(that.searchDataParam.pageNo == 1) that.total = res.data.totalCount;
        console.log(res.data)

        that.basetableinfo = res.data.list;
        //遍历数据，重置格式
        if(res.data) {
          that.basetableinfo.forEach((item, index) => {
            item.addTime = that.$utils.isEmpty(item.addTime) ? "--" : that.$utils.getDateTime(item.addTime);

          })
        }


      })
    },
    /**
     * 搜索按钮
     */
    searchBtnClick(option){
      this.searchDataParam = Object.assign(this.searchDataParam,option);
      if(!this.$utils.isEmpty(this.searchDataParam.orderNo) || !this.$utils.isEmpty(this.searchDataParam.productNum)|| !this.$utils.isEmpty(this.searchDataParam.addUserId) || !this.$utils.isEmpty(this.searchDataParam.expressNum) || !this.$utils.isEmpty(this.searchDataParam.expressCode) || !this.$utils.isEmpty(this.searchDataParam.printTime) ){
        this.searchDataParam.pageNo = 1;
        this.getOrderPrintList()
      }else{
        this.$message.warning('请输入查询条件')
      }
    },
    /**
     * 设置页码
     */
    currentChange(val){
      this.searchDataParam.pageNo = val;
      this.getOrderPrintList()
    },
    /**
     * 设置页码
     */
    sizeChange(val){
      this.searchDataParam.pageSize = val;
      this.getOrderPrintList()
    },
    /**
     * 重打面单按钮点击事件
     * @param {Object} scope
     */
    resetIntimidateItemOrder(scope,evt) {
      let target = evt.target;
      if(target.nodeName == "SPAN"){
        target = evt.target.parentNode;
      }
      target.blur();
      this.currentChooseOrderIds = [];
      this.currentChooseOrderIds.push({'orderNo':scope.row.id});

      this.resetIntimidateOrder();

    },
    /**
     * 重新打单按钮点击事件
     */
    resetIntimidateOrder(evt) {
      if(evt){
        let target = evt.target;
        if(target.nodeName == "SPAN"){
          target = evt.target.parentNode;
        }
        target.blur();
      }
      let that = this;
      if(that.currentChooseOrderIds.length <= 0) {
        that.$message.warning("请选择要打印的订单");
        return
      }
      let orderIds = [];

      that.currentChooseOrderIds.forEach((item)=>{
        orderIds.push(item.orderNo)
      })
      that.$loading();
      that.$http.postRaw(that.$api.rePrintOrderApi, {
        // "pageNo": 1,
        // "pageSize": that.searchDataParam.pageSize,
        "queryType": "send",  //noPrint 未打单 noSend 未发货  send 已发货
        "productBatch": that.searchDataParam.productionBatch,
        "productAccount": that.searchDataParam.productionAccount,
        "productNum": that.searchDataParam.productionCode,
        "productStartTime": that.$utils.isEmpty(that.searchDataParam.productionTime) ? "" : that.searchDataParam.productionTime[0],
        "productEndTime": that.$utils.isEmpty(that.searchDataParam.productionTime) ? "" : that.searchDataParam.productionTime[1],
        "printStartTime": that.$utils.isEmpty(that.searchDataParam.intimidateTime) ? "" : that.searchDataParam.intimidateTime[0],
        "printEndTime": that.$utils.isEmpty(that.searchDataParam.intimidateTime) ? "" : that.searchDataParam.intimidateTime[1],
        "express": that.searchDataParam.expressMode,
        "proName": that.searchDataParam.productName,
        "expressNum": that.searchDataParam.expressNo,
        "orderType": that.searchDataParam.orderType,
        "orderIds": orderIds.toString(),
      }).then(res => {
        that.$loading().close();
        if(res.code == 200) {
          let resultData = res.data;

          //执行打单操作
          that.printDoOrder(resultData);
        }
      })
    },
    /**
     * 执行打单操作
     * @param {Object} resultData
     */
    printDoOrder(resultData) {
      let that = this;
      if (resultData != null && resultData.length > 0) {
        resultData.forEach((item, index) => {
          that.generateUUid(item);
        })
      } else {
        that.$loading().close();
        that.$message.error("未获取到打单信息");
      }
    },
    /**
     * 发送打印数据
     * @param {Object} order_no
     * @param {Object} track_no
     * @param {Object} params
     * @param {Object} sign
     * @param {Object} print_data
     * @param {Object} product_num
     * @param {Object} product_name
     * @param {Object} product_count
     * @param {Object} baseTemplateUrl
     * @param {Object} templateUrl
     * @param {Object} printer
     */
    doPrint(order_no, track_no, params, sign, print_data, product_num, product_name, product_count, baseTemplateUrl, templateUrl, printer) {
      let that = this;
      let request = {
        cmd: "print",
        requetID: that.getUUID(8,16),
        version: "1.0",
        task: {
          "taskID": that.getUUID(8,16),
          "printer": printer,
          "documents": [{
            "documentID": track_no,//运单号，可选
            "contents": [{
              "params": params,
              "signature": sign,
              "encryptedData": print_data,
              "templateURL": baseTemplateUrl,
              "addData": {
                "senderInfo": {
                  "address": {
                    "cityName": "石家庄市",
                    "countryCode": "CHN",
                    "detailAddress": "ICC环球智汇中心写字楼C座809",
                    "districtName": "裕华区",
                    "provinceName": "河北省"
                  },
                  "contact": {
                    "mobile": "0311-88898111",
                    "name": "美印兔兔"
                  }
                }
              },
              "config": {
                "printlogo": true
              }
            }, {
              //自定义模板，如果没有，就不要传此对象
              "data": {
                "productInfo": product_name,
                "shopName": order_no,
                "orderId": product_num,
                "productCount": product_count + '件'
              },
              "templateURL": templateUrl
            }]
          }]
        }
      };
      that.$loading().close();
      that.socket.send(JSON.stringify(request));
    },
    /**
     * 获取UUID
     */
    getUUID(len, radix) {
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
      var uuid = [], i;
      radix = radix || chars.length;
      if (len) {
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
      } else {
        var r;
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
        uuid[14] = '4';
        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | Math.random() * 16;
            uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r];
          }
        }
      }
      return uuid.join('');
    },
    /**
     * 获取UUID
     */
    generateUUid(item) {
      let that = this;
      let order_no = item.orderNo;
      let track_no = item.trackNo;
      let params = item.param;
      let sign = item.sign;
      let printer = item.printer;
      let print_data = item.printerData;
      let product_num = item.productNum;
      let product_name = item.productName;
      let product_count = item.productCount;
      let logistics_code = item.logisticsCode;
      let baseTemplateUrl = item.baseTemplateUrl;
      let templateUrl = item.templateUrl;
        that.$utils.saveServiceLog(1,'开始打单trackNo:' + item.trackNo)
      that.doPrint(order_no, track_no, params, sign, print_data, product_num, product_name, product_count, baseTemplateUrl, templateUrl, printer);

    },
    /**
     * 退回未打印按钮点击事件
     * @param {Object} scope
     */
    revertOrderPrintStatus(scope) {
      let that = this;
      that.$loading();
      console.log(scope.row)
      that.$http.postRaw(that.$api.revertOrderPrintStatusApi, {
        "orderId": scope.row.id.toString(),
        "userId": scope.row.osUserId.toString()
      }).then(res => {
        that.$loading().close();
        if(res.code == 200) {
          that.$message.success("已退回");

          setTimeout(function() {
            that.getOrderPrintList();
          }, 1000);
        }
      }).catch(err => {
        that.$loading().close();
      })
    },
	/**
	 * 导出
	 */
	exportBtnClick() {
		let that = this;
		if(that.$utils.isEmpty(that.searchDataParam.printTime)){
			this.$message('请选择时间')
			return
		}
		this.$confirm('是否只导出当前页？', '提示', {
			confirmButtonText: '是',
			cancelButtonText: '导出全部',
			distinguishCancelAndClose: true, // 重要，设置为true才会把右上角X和取消区分开来
			type: 'warning',
			center: true
		}).then((action) => {
			that.exportDyOrder(1);
			console.log('导出当前页')
		}).catch((action) => {
			if (action === 'cancel') {
				that.exportDyOrder(0);
				console.log('导出全部')
			}
		});
	},
	/**
	 * 导出数据
	 * @param {Object} type  1：导出当前页     0：导出全部
	 */
	exportDyOrder(type) {
		let that = this;
		that.$loading();
		that.$http.post(that.$api.exportPrintOrderRecordListApi, {
			"pageNo": that.searchDataParam.pageNo,
			"pageSize": that.searchDataParam.pageSize,
			"orderNo": that.searchDataParam.orderNo,
			"productNum": that.searchDataParam.productNum,
			"expressNum": that.searchDataParam.expressNum,
            "expressCode": that.searchDataParam.expressCode,
			"addUserId": that.searchDataParam.addUserId,
			"printStartTime": that.$utils.isEmpty(that.searchDataParam.printTime) ? "" : that.searchDataParam.printTime[0],
			"printEndTime": that.$utils.isEmpty(that.searchDataParam.printTime) ? "" : that.searchDataParam.printTime[1],
			"expFlag": type,
		}).then(res => {
			that.$loading().close();
			if (res.code == 200) {
				that.$message.success("导出成功，请到我的文件查看");
			}
		})
	},
    /**
     * 关闭订单详情
     */
    dialogClose(){
      this.isShowOrderDetailsCover = false;
    },
    /**
     * 复选框
     */
    selectionChange(val){
      this.currentChooseOrderIds = val;
      console.log(val)
    }
  },
}
</script>
<style>
html,body{
  min-width: 900px!important;
}

</style>
<style scoped>
.mainCont .container{
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 12px;
  box-sizing: border-box;
}
.remainderOrderNum{
  font-size: 14px;
  color: #333;
  line-height: 30px;
  background-color: #fff;
  padding-left: 12px;
  box-sizing: border-box;
  font-weight: 600;
  margin-bottom: 16px;
}
/* 订单详情遮罩层 */
.orderDetailsDiv{
  width: 500px !important;
}
.orderDetailsInfo{
  overflow: auto;
  font-size: 13px;
  /*margin: 0 20px 30px;*/
  max-height: 750px;
  overflow-y: scroll;
}
.orderDetailsInfoItem{
  width: 100%;
  margin-top: 12px;
  overflow: auto;
}
.orderDetailsInfoItem span{
  width: 90px;
  display: inline-block;
  float: left;
  color: #666;
  line-height: 22px;
}
.orderDetailsInfoItem p{
  width: calc(100% - 90px);
  font-size: 13px;
  float: left;
  word-break: break-all;
  line-height: 22px;
}



/* 导出遮罩层 */
.exportDataCover, .orderDetailsCover{
  background-color: rgba(0, 0, 0, .5);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.exportDataDiv, .orderDetailsDiv{
  width: 400px;
  padding: 10px;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 5px;
  animation: fadeInDown 0.5s;
}
.coverTitle{
  text-align: center;
  font-size: 16px;
  color: #000;
  line-height: 40px;
}
.closeCoverDiv{
  width: 30px;
  height: 30px;
  top: 15px;
  right: 15px;
  cursor: pointer;
}
.closeCoverDiv img{
  width: 20px;
}
.coverDesc{
  padding: 0 15px;
  line-height: 20px;
  font-size: 14px;
  text-align: center;
  margin: 30px 0 40px;
}
.coverOptionBtn{
  margin-bottom: 20px;
}
.coverOptionBtn button{
  width: 90px;
  height: 35px;
  padding: 0 !important;
  text-align: center;
}
.coverOptionBtn button.cancelBtn{
  background: none !important;
  color: #009688 !important;
}
.intimidateBtn{
  background-color: #FFB800 !important;
  border-color: #FFB800 !important;
}
.changeExpressBtn{
  background-color: #1E9FFF !important;
  border-color: #1E9FFF !important;
}
.exportBtn{
  background: #2F4056 !important;
  border-color: #2F4056 !important;
}
</style>